import { render, staticRenderFns } from "./GptBroadcast.vue?vue&type=template&id=372aa45c&scoped=true"
import script from "./GptBroadcast.vue?vue&type=script&lang=js"
export * from "./GptBroadcast.vue?vue&type=script&lang=js"
import style0 from "./GptBroadcast.vue?vue&type=style&index=0&id=372aa45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372aa45c",
  null
  
)

export default component.exports